// removed by extract-text-webpack-plugin
module.exports = {"login-modal-group-wrapper":"ModalGroup__login-modal-group-wrapper","loginModalGroupWrapper":"ModalGroup__login-modal-group-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/ModalGroup/ModalGroup.scss
// module id = 1680
// module chunks = 8